import styled from '@emotion/styled'

import { breakpoints } from '../../utils/styles'

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(
    ${props => (props.count ? props.count : 3)},
    1fr
  );
  gap: 2.5rem;
  position: relative;

  margin: 0 auto;
  padding: 2.5rem 2.5rem 0 2.5rem;

  @media (max-width: ${breakpoints.s}px) {
    grid-template-columns: repeat(1, 1fr);
    padding: 20px 20px 0;
  }
`

export const Product = styled.div`
  display: flex;
  flex-direction: column;
`

export const Title = styled.h3`
  font-size: 1.8rem;
  margin-bottom: 0;
  text-align: center;
  margin-top: 10px;
`

export const PriceTag = styled.span`
  font-weight: 300;
  font-size: 1rem;
  text-align: center;
  margin-top: 15px;

  :before {
    content: '- ';
  }
`
